<template>
  <v-layout class="timeline" wrap>
    <div class="timeline-header">
      <v-icon>mdi-routes</v-icon>
      TIMELINE DE EVENTOS
    </div>
    <div style="bottom: 105px" id="list-timeline-sidebar"></div>
    <div
      class="timeline-operation-wrapper"
      v-for="(history, index) in TransactionHistory"
      :key="history.id"
      wrap
    >
      <p class="step-name refund refunded">
        <span class="step-index ng-binding">{{
          TransactionHistory.length - index
        }}</span>
        <span>{{ history.type | transactionTitle }} </span>
        <v-icon color="#8879b4;" small>check</v-icon>
      </p>
      <div class="op-header-data">
        <material-stats-card
          v-if="history.type === 'capture'"
          :color="history.status | transactionColor"
          icon="mdi-currency-usd"
          title="CAPTURADA"
          :value="
            (history.metadata.environment.captured_amount / 100)
              | formatCurrency
          "
          :small-value="history.processor_response_code"
          sub-icon="mdi-calendar"
          :sub-text="history.started_at | msToDate"
        />
        <material-stats-card
          v-if="history.type === 'authorize'"
          :color="history.status | transactionColor"
          :icon="
            history.status === 'success'
              ? 'mdi-checkbox-marked-circle-outline'
              : 'mdi-close-circle-outline'
          "
          title="AUTORIZADA"
          :value="
            history.metadata.environment.authorization_code ||
            history.metadata.environment.tid
          "
          small-value="CÓD."
          sub-icon="mdi-calendar"
          :sub-text="history.started_at | msToDate"
        />
        <material-stats-card
          v-if="history.type === 'issue'"
          :color="history.status | transactionColor"
          :icon="
            history.status === 'success'
              ? 'mdi-barcode'
              : 'mdi-close-circle-outline'
          "
          title="BOLETO"
          value="EMITIDO"
          :small-value="history.processor_response_code"
          sub-icon="mdi-calendar"
          :sub-text="history.started_at | msToDate"
        />
        <material-stats-card
          v-if="history.type === 'conciliate'"
          :color="history.status | transactionColor"
          :icon="
            history.status === 'success'
              ? 'mdi-checkbox-marked-outline'
              : 'mdi-close-circle-outline'
          "
          title="BOLETO"
          value="PAGO"
          :small-value="history.processor_response_code"
          sub-icon="mdi-calendar"
          :sub-text="history.started_at | msToDate"
        />
        <material-stats-card
          v-if="history.type === 'refund'"
          color="#8879b4"
          icon="mdi-backup-restore"
          title="ESTORNADA"
          :value="
            (history.metadata.environment.refunded_amount / 100)
              | formatCurrency
          "
          :small-value="history.processor_response_code"
          sub-icon="mdi-calendar"
          :sub-text="history.started_at | msToDate"
        />
      </div>
    </div>
  </v-layout>
</template>
<script>
import { GET_TRANSACTION_HISTORY } from "../../graphql/transactionHistory";
import moment from "moment";

export default {
  props: ["transaction_id"],
  data: () => ({
    TransactionHistory: {},
  }),
  created() {
    // console.log('tm transaction_id: ', this.transaction_id)
    this.$apollo
      .query({
        // gql query
        query: GET_TRANSACTION_HISTORY,
        // Reactive parameters
        variables: {
          // Use vue reactive properties here
          transaction_id: this.transaction_id,
        },
      })
      .then((transactionHistory) => {
        // Seta as faturas no eventBus para o outro Componente
        this.TransactionHistory = transactionHistory.data.transactionHistory;
      })
      .catch((error) => {
        console.error("Erro ao capturar histórico de Transação. ", error);
      });
  },
  filters: {
    transactionTitle: function (value) {
      if (value === "capture") return "CAPTURA";
      else if (value === "authorize") return "AUTORIZAÇÃO";
      else if (value === "refund") return "ESTORNO";
      else if (value === "issue") return "BOLETO EMITIDO";
      else if (value === "conciliate") return "BOLETO PAGO";
      else return value;
    },
    msToTime: function (duration) {
      var // milliseconds = parseInt((duration%1000)/100),
        seconds = parseInt((duration / 1000) % 60),
        minutes = parseInt((duration / (1000 * 60)) % 60),
        hours = parseInt((duration / (1000 * 60 * 60)) % 24);

      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      return hours + ":" + minutes + ":" + seconds; // + "." + milliseconds.toFixed(0);
    },
    msToDate: function (duration) {
      if (duration === "" || duration === "null") return "";
      else return moment(parseInt(duration)).format("DD/MM/YYYY HH:mm:ss");
    },
    transactionResponse: function (code) {
      if (code === "" || code === "null") return "";
      else if (code === "0") return "Transação autorizada";
      else if (code === "1000") return "Transação não autorizada";
      else return code;
    },
    transactionColor: function (status) {
      if (status === "" || status === "null") return "green";
      else if (status === "success") return "blue";
      else return "red";
    },
  },
};
</script>
<style>
.timeline {
  /* background-color: #FFF; */
  padding-top: 20px;
}
.timeline-header {
  border-bottom: 1px solid #8e8e8e;
  padding-bottom: 5px;
  /* margin-right: 120px; */
  margin-bottom: 25px;
  font-size: 25px;
  font-weight: 400;
  color: #8e8e8e;
}
.timeline #list-timeline-sidebar {
  position: absolute;
  top: 217px;
  left: 15px;
  /* bottom: 25px; */
  width: 5px;
  background-color: #d5d5d5;
  border-radius: 10px;
}
.timeline .timeline-operation-wrapper {
  transition: all 0.5s ease-out;
  /* padding-left: 20px; */
  position: relative;
  margin-bottom: 10px;
  margin-left: -57px;
  padding-left: 80px;
  width: 125%;
}

.timeline .timeline-operation-wrapper p.step-name {
  font-size: 25px;
  color: #000;
  font-weight: 800;
}

.timeline
  .single-operation-wrapper
  .maximized
  .op-detail-header
  .op-header-data {
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  float: right;
  margin-right: 10px;
}

.timeline .timeline-operation-wrapper p.step-name span {
  opacity: 0.5;
  transition: all 0.5s ease-out;
}

.timeline .timeline-operation-wrapper.active p.step-name.refund:before {
  background-color: #c3bcd9;
}

.timeline .timeline-operation-wrapper p.step-name.refund:before {
  background-color: #c3bcd9;
}

.timeline .timeline-operation-wrapper p.step-name .step-index {
  color: #8e8e8e;
  font-size: 22px;
  font-weight: 600;
  margin-right: 3px;
}

/* .timeline .timeline-operation-wrapper p.step-name .status-icon.refund {
    color: #8879b4;
} */

.timeline .timeline-operation-wrapper p.step-name:before {
  content: " ";
  position: absolute;
  transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  -webkit-transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  -moz-transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  -o-transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  left: 55px;
  top: 18px;
  margin-top: -8px;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  opacity: 1 !important;
}

.timeline .single-operation-wrapper {
  position: relative;
  transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  -webkit-transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  -moz-transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  -o-transition: all 0.5s cubic-bezier(0, 0.15, 0, 1.02);
  background-color: #ebebeb;
  border-radius: 3px;
  overflow: hidden;
  height: 65px;
  width: 305px;
  opacity: 0.5;
  margin-bottom: 5px;
  cursor: pointer;
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.timeline .single-operation-wrapper .op-details {
  height: 100%;
  width: 35%;
}

.timeline .single-operation-wrapper .op-details > div {
  position: relative;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  margin-left: 12px;
}
</style>
